export enum SlotStatus {
    AVAILABLE = 'available',
    RESERVED = 'reserved'
}
